/* eslint-disable */

export function generateTextFromJson(json,textPass) {
    const labels = {
      dlsKey: "رقم المفتاح",
      parcelId: "رقم القطعة",
      hodName: "الحوض",
      vellName: "القرية",
      hodCode: "رقم الحوض",
      userNationalId:"الرقم الوطني لصاحب الأرض",
      ePaymentNumber:"رقم الدفع الالكتروني",
      DESCRIPTION:"وصف و سبب التعديل",
      NAME:"الصفة",
      BUILT_UP_AREA_PERCENT:"النسبة المئوية لمساحة البناء",
      SETBACK_FRONT:"الإرتداد الأمامي",
      SETBACK_BACK:"الإرتداد الخلفي",
      MIN_PLOT_AREA:"الحد الأدنى من مساحة الإفراز",
      MAX_HEIGHT:"الحد الأعلى لإرتفاع البناء",
      created_date_to:"من تاريخ",
      created_date_from:"الى تاريخ",
      STATUS:"حالة الطلب",
      TYPE:"نوع الطلب",
      paymentDate:"تاريخ الدفع",
      email:"الايميل",
      firstName:"الاسم الاول",
      lastName:"الاسم الاخير",
      roleId:"نوع المستخدم",
      permissionArray:"صلاحيات",
      userId:"رقم الحساب",
      isActive:"ما قام به المستخدم",
      feildStatus:""
    };
  
    let text = "";
  
    if (textPass) {
      text += `${textPass} : `;
    }
    if (json.userId) {
      text += `${labels.userId}: ${json.userId}, `;
    }
    if (json.isActive) {
      text += `${labels.isActive}: ${json.isActive=="true"?"تعطيل الحساب":"تفعيل الحساب"}, `;
    }


    if (json.STATUS) {
      let statusText = '';
      switch (Number(json.STATUS)) {
        case 1:
          statusText = 'تحت المعالجة';
          break;
        case 2:
          statusText = 'مرفوض';
          break;
        case 3:
          statusText = 'معتمد';
          break;
        default:
          statusText = 'غير معروف';
      }
      text += `${labels.STATUS}: ${statusText}, `;
    }


    if (json.roleId) {
      let statusText = '';
      switch (Number(json.roleId)) {
        case 1:
          statusText = 'موظف';
          break;
        case 2:
          statusText = 'مدير نظام';
          break;
        case 3:
          statusText = 'مدير';
          break;
        default:
          statusText = 'غير معروف';
      }
      text += `${labels.roleId}: ${statusText}, `;
    }
    
    if (json.TYPE) {
      let typeText = '';
      switch (Number(json.TYPE)) {
        case 1:
          typeText = 'تعديل استعمال قطع';
          break;
        case 2:
          typeText = 'تعديل احكام استعمال';
          break;
        default:
          typeText = 'غير معروف';
      }
      text += `${labels.TYPE}: ${typeText}, `;
    }

    if (json.created_date_to) {
      text += `${labels.created_date_to}: ${json.created_date_to}, `;
    }
    if (json.firstName) {
      text += `${labels.firstName}: ${json.firstName}, `;
    }
    if (json.lastName) {
      text += `${labels.lastName}: ${json.lastName}, `;
    }
    if (json.email) {
      text += `${labels.email}: ${json.email}, `;
    }
    if (json.paymentDate) {
      text += `${labels.paymentDate}: ${json.paymentDate}, `;
    }
    if (json.created_date_from) {
      text += `${labels.created_date_from}: ${json.created_date_from}, `;
    }

    if (json.MIN_PLOT_AREA) {
      text += `${labels.MIN_PLOT_AREA}: ${json.MIN_PLOT_AREA}, `;
    }
    if (json.MAX_HEIGHT) {
      text += `${labels.MAX_HEIGHT}: ${json.MAX_HEIGHT}, `;
    }

    if (json.DESCRIPTION) {
      text += `${labels.DESCRIPTION}: ${json.DESCRIPTION}, `;
    }
    if (json.NAME) {
      text += `${labels.NAME}: ${json.NAME}, `;
    }
    if (json.SETBACK_BACK) {
      text += `${labels.SETBACK_BACK}: ${json.SETBACK_BACK}, `;
    }
    if (json.SETBACK_FRONT) {
      text += `${labels.SETBACK_FRONT}: ${json.SETBACK_FRONT}, `;
    }
    if (json.DLS_KEY) {
      text += `${labels.dlsKey}: ${json.DLS_KEY}, `;
    }
    if (json.dlsKey) {
      text += `${labels.dlsKey}: ${json.dlsKey}, `;
    }

  
    if (json.PARCEL_ID) {
      text += `${labels.parcelId}: ${json.PARCEL_ID}, `;
    }
  
    if (json.HOD_NAME) {
      text += `${labels.hodName}: ${json.HOD_NAME}, `;
    }
  
    if (json.VELL_NAME) {
      text += `${labels.vellName}: ${json.VELL_NAME}, `;
    }
  
    if (json.HOD_CODE) {
      text += `${labels.hodCode}: ${json.HOD_CODE}`;
    }
    if(json.userNationalId){
      text +=`${labels.userNationalId}:${json.userNationalId} `
    }
    if(json.ePaymentNumber){
      text +=`${labels.ePaymentNumber}:${json.ePaymentNumber} `
    }

    if(json.feildStatus){
      text +=`${labels.feildStatus}:${json.feildStatus=="true"?"مدفوع":"ملغي"} `
    }

    text = text.trim();
    if (text.endsWith(',')) {
      text = text.substring(0, text.length - 1);
    }
  
    return text;
  }